export const dietCheckboxOptions = [
  { key: "Balanced", value: "balanced" },
  { key: "High-Protein ", value: "high-protein" },
  { key: "Low-Carb", value: "low-carb" },
  { key: "Low-Fat", value: "low-fat" },
];
